export function Mandala({ className = "" }) {
  return (
    <svg viewBox="0 0 200 200" className={className} aria-hidden="true" fill="none">
      <g stroke="currentColor" strokeWidth="0.6">
        {Array.from({ length: 24 }).map((_, i) => (
          <line key={i} x1="100" y1="100" x2="100" y2="4"
            transform={`rotate(${i * 15} 100 100)`} />
        ))}
        {[92, 72, 52, 34, 18].map((r, i) => (
          <circle key={i} cx="100" cy="100" r={r} />
        ))}
        {Array.from({ length: 12 }).map((_, i) => (
          <ellipse key={i} cx="100" cy="46" rx="9" ry="26"
            transform={`rotate(${i * 30} 100 100)`} />
        ))}
      </g>
    </svg>
  );
}
